/* claude- (2026-09-28) Add 6 / Add 12 / Add 24 / Custom amount on the wholesale product page.
   Adds the currently selected variant (the form's id input, which the variant picker keeps
   current) and opens the cart drawer, the same place Add to cart lands. */
(function () {
  'use strict';
  function variantId(box) {
    var form = box.closest('form');
    var input = form && form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }
  function add(box, qty) {
    var id = variantId(box), msg = box.querySelector('.cc-quickqty__msg');
    qty = parseInt(qty, 10);
    if (!id || !qty || qty < 1) { if (msg) msg.textContent = 'Type how many hats you want.'; return; }
    var btns = box.querySelectorAll('button');
    btns.forEach(function (b) { b.disabled = true; });
    if (msg) msg.textContent = 'Adding ' + qty + '…';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (msg) msg.textContent = res.j.description || 'Could not add that many.'; return; }
        if (msg) msg.textContent = 'Added ' + qty + ' to your cart.';
        if (typeof window.claudeCartOpen === 'function') window.claudeCartOpen();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { if (msg) msg.textContent = 'Could not add to the cart. Please try again.'; })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cc-quickqty__btn');
    if (!b) return;
    var box = b.closest('[data-cc-quickqty]');
    if (b.hasAttribute('data-qty')) add(box, b.getAttribute('data-qty'));
    else if (b.hasAttribute('data-custom')) {
      var c = box.querySelector('.cc-quickqty__custom'); c.hidden = !c.hidden;
      if (!c.hidden) c.querySelector('input').focus();
    } else if (b.hasAttribute('data-go')) add(box, box.querySelector('.cc-quickqty__custom input').value);
  });
  /* The product page stepper never goes below 3 (Adam, 2026-09-28: "don't let them go below 3 hats
     in the +- area so - only shows up if there are 4 or more"). The input's min="3" stops the minus
     button; this hides it at 3 and puts a typed 1 or 2 back to 3. Cart lines are not touched. */
  function qtyInputs() { return document.querySelectorAll('quantity-input input[name="quantity"]'); }
  function sync(input, clamp) {
    var MIN = parseInt(input.getAttribute('min'), 10) || 1;   /* 3, or 1 for stickers (set by quantity-input.liquid) */
    var v = parseInt(input.value, 10);
    if (clamp && !(v >= MIN)) { input.value = MIN; v = MIN; }
    var box = input.closest('quantity-input');
    if (box) box.classList.toggle('cc-qty-at-min', !(v > MIN));
  }
  function syncAll() { qtyInputs().forEach(function (i) { sync(i, true); }); }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('quantity-input .qty-input__btn')) return;
    var i = e.target.closest('quantity-input').querySelector('input[name="quantity"]');
    if (i) sync(i, true);
  });
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('quantity-input input[name="quantity"]')) sync(e.target, false); });
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('quantity-input input[name="quantity"]')) sync(e.target, true); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.cc-quickqty__custom')) {
      e.preventDefault(); add(e.target.closest('[data-cc-quickqty]'), e.target.value);
    }
  });
})();
